import {
  Component,
  computed,
  DestroyRef,
  inject,
  PLATFORM_ID,
  signal,
} from '@angular/core';
// import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ScrollTopModule } from 'primeng/scrolltop';
// import { FlagLanguagePipe, InfoLanguagePipe } from '@ls-commons/utils/pipes';
import { debounceTime, fromEvent, map, startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { isPlatformBrowser } from '@angular/common';
import { AppConfigService } from '../../../services/app-config.service';
import { ThemeService } from '../../../services/theme.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [ScrollTopModule, ButtonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private platform = inject(PLATFORM_ID);
  hiddenTitle = true;
  hiddenLogo = true;

  private _isMobile = signal<boolean>(true);
  public isMobile = computed(() => this._isMobile());
  private _isTablet = signal<boolean>(true);
  public isTablet = computed(() => this._isTablet());

  destroyRef = inject(DestroyRef);
  app = inject(AppConfigService);
  theme = inject(ThemeService);

  readonly currentYear = new Date().getFullYear();

  constructor() {
    if (isPlatformBrowser(this.platform)) {
      // fromEvent(window, 'resize')
      //   .pipe(
      //     map((resize: Event) => (resize.target as Window).innerWidth),
      //     // startWith(window.innerWidth),
      //     debounceTime(200),
      //     takeUntilDestroyed(this.destroyRef),
      //   )
      //   .subscribe((width) => {
      //     this._isMobile.set(width <= 1024);
      //     this._isTablet.set(width <= 1024 && width > 640);
      //   });
      // // Inicializar valores basados en window.innerWidth
      // const width = window.innerWidth;
      // this._isMobile.set(width <= 1024);
      // this._isTablet.set(width <= 1024 && width > 640);
    }
  }
}
